import { useGetAllTrainerList } from '../../assets/nodeApi/getApi/getHrApi'
import { useState } from 'react'
import { Box, Button, Grid2, Typography } from '@mui/material'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { Field } from 'formik';
import CustomDivider from '../../shared/utils/CustomDivider'
import { useHrDropdownOptions } from './HrOption'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { formatKey } from '../../shared/formatter'

const HrAcceptedTrainerList = () => {
    const { trainerStatus } = useHrDropdownOptions()
    const [selectedTrainer, setSelectedTrainer] = useState({})
    const [filters, setFilters] = useState({})
    const { open: openSalary, handleClickOpen: handleClickOpenSalary, handleClose: handleCloseSalary } = useDialog();
    const { data: trainerList, isLoading: istrainerLoading } = useGetAllTrainerList({ salaryExists: true, ...filters })
    const trainerOption =
        trainerList?.data?.map((item, index) => ({
            sr_no: index + 1,
            id: item?.id,
            ...item
        })) ?? [];

    const trainerColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "name",
            headerName: "Name",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params.row.firstname} {""} {params.row.lastname}</Typography>,
        },
        {
            field: "username",
            headerName: "User Name",
            width: 180,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "mobile",
            headerName: "Mobile Number",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "salary",
            headerName: "Salary",
            width: 160,
            renderCell: (params) => {
                const resumePath = params?.row?.trainer_salary?.id;

                if (!resumePath) {
                    return (
                        <Typography variant="body2">
                            No Salary Added
                        </Typography>
                    );
                }

                return (
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                            handleClickOpenSalary()
                            setSelectedTrainer(params?.row)
                        }}
                    >
                        View Salary
                    </Button>
                );
            },
        },

        {
            field: "status",
            headerName: "Status",
            width: 180,
            renderCell: (params) => {


                return (
                    <Typography variant="body2">
                        {params?.row?.user_resumes?.status}
                    </Typography>
                );
            },
        },

    ];

    return (
        <>
            <TableFilterTemplate
                title="Onboarded Trainers"
                columns={trainerColumn}
                rowsData={trainerOption || []}
                isLoading={istrainerLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="status"
                                component={AutoCompleteField}
                                options={trainerStatus.options}
                                label="Status"
                                maxDate={values?.to_date || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
            <MainDialogBox open={openSalary} handleClose={handleCloseSalary} width={"40%"} heading={"Salary Detail"} headingVariant={"h3"}>
                <CustomDivider size={"1rem"} />
                <Box>
                    {Object.entries({
                        ...selectedTrainer?.trainer_salary,
                        ...selectedTrainer?.user_resumes?.terms
                    } ?? {})
                        .filter(([key, value]) =>
                            value !== null &&
                            !["id", "created_at", "updated_at"].includes(key)
                        )
                        .map(([key, value]) => {

                            // If value is array → convert to comma separated string
                            const displayValue = Array.isArray(value)
                                ? value.join(", ")
                                : ` ${value} `;

                            return (
                                <Box display="flex" alignItems="center" key={key} mb={1}>
                                    <Typography
                                        variant="body1"
                                        fontWeight={600}
                                        sx={{ width: "35%", display: "inline-block" }}
                                    >
                                        {formatKey(key)}
                                    </Typography>

                                    <Typography
                                        variant="body1"
                                        sx={{ width: "5%", textAlign: "center" }}
                                    >
                                        :
                                    </Typography>

                                    <Typography
                                        variant="body1"
                                        sx={{ width: "50%", wordBreak: "break-word" }}
                                    >
                                        {displayValue}
                                    </Typography>
                                </Box>
                            );
                        })}
                </Box>
            </MainDialogBox>
        </>
    )
}

export default HrAcceptedTrainerList

